import { render, staticRenderFns } from "./ButtonShareModal.vue?vue&type=template&id=bac570b6"
import script from "./ButtonShareModal.vue?vue&type=script&lang=ts"
export * from "./ButtonShareModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports